<template>
    <BaseNotification theme="info" :text="t('analytics.filters.notice')" hide-dismiss class="px-2.5 py-4" />
    <div class="hidden md:flex w-full justify-between items-center gap-4">
        <span class="mr-4 body-small text-control-label-disabled">{{ t("analytics.filters.heading") }}</span>
        <BaseSelect disabled icon="bi-filter" :placeholder="t('analytics.filters.placeholder')" />
        <BaseSelect disabled icon="bi-filter" :placeholder="t('analytics.filters.placeholder')" />
        <BaseSelect disabled icon="bi-filter" :placeholder="t('analytics.filters.placeholder')" />
        <BaseSelect disabled icon="bi-filter" :placeholder="t('analytics.filters.placeholder')" />
    </div>
</template>

<script setup lang="ts">
import BaseNotification from "~vue/components/BaseNotification.vue";
import BaseSelect from "~vue/components/BaseSelect.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>
